import { _ as r } from "../internals/export.js";
import { a as e } from "../internals/array-buffer-view-core.js";
r({
  target: "ArrayBuffer",
  stat: !0,
  forced: !e.NATIVE_ARRAY_BUFFER_VIEWS
}, {
  isView: e.isView
});